import React from 'react';
import logo from '../../assets/footer_logo.jpg';
import './Footer.scss';
import { FaFacebookF, FaInstagram, FaTwitter} from "react-icons/fa";
import { Link } from 'react-router-dom';
import call from '../../assets/footer/calling.png';
import time from '../../assets/footer/time.png';
import location from '../../assets/footer/location.png';
import leafLogo from '../../assets/banner/leaf.png'

const Footer = () => {

    const footerMenu = [
        {
            'name' : 'Home',
            'link' : '/'
        },
        {
            'name' : 'About',
            'link' : '/about'
        },
        {
            'name' : 'Services',
            'link' : '/services'
        },
        {
            'name' : 'General Dentistry',
            'link' : '/services'
        },
        {
            'name' : 'Dental Implants',
            'link' : '/services'
        },
        {
            'name' : 'Orthodontics',
            'link' : '/services'
        },
        {
            'name' : 'Team',
            'link' : '/team'
        },
        {
            'name' : 'Contact',
            'link' : '/contact'
        }
    ];

    const footerContacts = [
        {
            'title': 'Phone Number',
            'info': '(450) 241-0147',
            'icon': call
        },
        {
            'title': 'Open Hour',
            'info': '09:00 AM - 18:00 PM',
            'icon': time
        },
        {
            'title': 'Clinic Address',
            'info': '3025 Boul. Tessier Suite 106, Laval',
            'icon': location
        }
    ]

    return (
        <footer className='pt-100 pb-70'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-5">
                        <div className="footer-logo">
                            <img src={logo} alt="logo" />
                        </div>
                        <p>Loft Dentaire Laval is dedicated to providing the latest in dental services and procedures. Our staff is highly trained and prides itself on availability to all patients in need of care.</p>

                        <div className="social-logo">
                            <p>Follow us on</p>
                            <ul>
                                <li><a href="/"><FaFacebookF/></a></li>
                                <li><a href="/"><FaTwitter/></a></li>
                                <li><a href="/"><FaInstagram/></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                        <div className="footer-link">
                            <p>Quick Links</p>
                            <ul>
                                {
                                    footerMenu.map(singleMenu => <li><Link to="/">{singleMenu.name}</Link></li>)
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5">
                        <div className="footer-contact">
                            <p>Contact & Information</p>

                            {
                                footerContacts.map(footerContact => {
                                    return  <div className="contact-list">
                                                <div className="contact-icon">
                                                    <img src={footerContact.icon} alt="call" />
                                                </div>
                                                <div className="contact-text">
                                                    <p>{footerContact.title}</p>
                                                    <h5>{footerContact.info}</h5>
                                                </div>
                                            </div>
                                })
                            }
                        </div>
                    </div>
                </div>

                <div className="copyright-area">
                <div className='copy-text'>
                    <p>&copy; Loft Dentaire Laval. All Rights Reserved</p>
                </div>
                <div className='copy-links'>
                    <ul>
                    <li><Link to='/'>Terms of Use</Link></li>
                    <li><Link to='/'>Privacy Policy</Link></li>
                    </ul>
                </div>
                <div className='developer-credit'>
                    <p>
                    Website developed by{' '}
                    <a href="https://leaf-rd.com" target="_blank" rel="noopener noreferrer" className="developer-link">
                        <img src={leafLogo} alt="Leaf R&D" className="developer-logo" />
                        Leaf R&D
                    </a>
                    </p>
                </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
